/**
 * Created by ren on 14/07/2017.
 */
export const OPEN = "dt:transaction_status:open";
export const PENDING_APPROVAL = "dt:transaction_status:pendingapproval";
export const PENDING_RECEIPT = "dt:transaction_status:pendingreceipt";
export const PARTIALLY_RECEIVED = "dt:transaction_status:partiallyreceived";
export const PROCESSING = "dt:transaction_status:processing";
export const CLOSED = "dt:transaction_status:closed";
export const CLOSED_ABANDONED = "dt:transaction_status:closedabandoned";
export const ERROR = "dt:transaction_status:error";


export const ALL = [
  { "id"            : "dt:transaction_status:open",
    "id_ext"        : "6500000",
    "doc_type"      : "transaction_status",
    "name"          : "OPEN",
    "short_name"    : "Open",
    "closed"        : false,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:closed",
    "id_ext"        : "6500001",
    "doc_type"      : "transaction_status",
    "name"          : "CLOSED",
    "short_name"    : "Closed",
    "closed"        : true,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:pendingapproval",
    "id_ext"        : "6500002",
    "doc_type"      : "transaction_status",
    "name"          : "PENDING APPROVAL",
    "short_name"    : "Pending Approval",
    "closed"        : false,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:processing",
    "id_ext"        : "6500003",
    "doc_type"      : "transaction_status",
    "name"          : "PROCESSING",
    "short_name"    : "Processing",
    "closed"        : false,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:closedabandoned",
    "id_ext"        : "6500004",
    "doc_type"      : "transaction_status",
    "name"          : "CLOSED - ABANDONED",
    "short_name"    : "Closed Abandoned",
    "closed"        : true,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:pendingreceipt",
    "id_ext"        : "6500005",
    "doc_type"      : "transaction_status",
    "name"          : "PENDING RECEIPT",
    "short_name"    : "Pending Receipt",
    "closed"        : false,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:partiallyreceived",
    "id_ext"        : "6500006",
    "doc_type"      : "transaction_status",
    "name"          : "PARTIALLY RECEIVED",
    "short_name"    : "Partially Received",
    "closed"        : false,
    "active"        : true,
    "system_defined": true
  },
  { "id"            : "dt:transaction_status:error",
    "id_ext"        : "6500007",
    "doc_type"      : "transaction_status",
    "name"          : "ERROR",
    "short_name"    : "Error",
    "closed"        : false,
    "active"        : true,
    "system_defined": true
  }
];